/**
 * This file is to map delay condition , from and to BE structure, it should contain at least two functions, one that maps
 * from BE to FE structure, and the other one that maps from FE to BE structure
 */
import { ActionEvents } from "assets/js/scenes/automations/containers/editor/EventsConfigs";
import { convertSecondsToNearestUnit } from "assets/js/scenes/automations/containers/editor/utils/utils";
import {
	getEdge,
	getEndCoachmarkNode,
	getShadowsForStep,
} from "assets/js/scenes/automations/containers/editor/utils/utils";
import {
	getSubSteps,
	getLoopSpecificData,
	isContiniousOrFinite,
} from "./googleUtils";

const parseBELoopingToFE = (automation, mainStep, subStep, targetId) => {
	const events = [];
	events.push({
		id: mainStep.name,
		position: {
			x: 0,
			y: 0,
		},
		data: {
			name: ActionEvents()[1].name,
			desc: ActionEvents()[1].desc,
			type: "action",
			tileTitle: ActionEvents()[1].tileTitle,
			id: mainStep.name,
			baseId: "loop",
			initialElement: false,
			shadows: getShadowsForStep(automation, mainStep.name),
			// goTo: getMatchedConditionToEmitStep(
			// 	convertPlanToFlatArrayOfActions(automation),
			// 	subStep.args.switch[0].steps[1]
			// )?.id,
			// loopFor: subStep.args.switch[0].condition.lt.value,

			// waitFor: convertSecondsToNearestUnit(
			// 	subStep.args.switch[0].steps[1].args.params.delay
			//  ),
			//loopType: "finite",
			...getLoopSpecificData(automation, subStep),
		},
		type: "editorNode",
	});
	const links = [];
	if (targetId && isContiniousOrFinite(subStep) == "finite") {
		links.push(getEdge("custom", mainStep.name, targetId));
	} else {
		const endCoachmark = getEndCoachmarkNode(0, 0);
		events.push(endCoachmark);
		links.push(getEdge("custom", mainStep.name, endCoachmark.id));
	}
	return {
		events: events,
		links: links,
	};
};
const parseFELoopingToBE = (FEEvent, connectedEdges, events) => {
	let shadows = [];
	let inTos = [];
	if (FEEvent.data.shadows) shadows = [...FEEvent.data.shadows];
	inTos = events
		.filter((e) => e.data.baseId == "loop")
		.filter((e) => e.data.goTo == FEEvent.id);
	if (inTos.length > 0) inTos = inTos.map((e) => `${e.id}_loop`);
	const mainStep = [
		{
			steps: [
				{
					name: `${FEEvent.id}`,
					action: "SubAutomation.Call",
					args: {
						sub_automation: FEEvent.id,
					},
					next: "end",
					shadows: shadows,
					inTos: inTos,
				},
			],
		},
	];
	const subSteps = getSubSteps(FEEvent, connectedEdges, events);
	return {
		main: mainStep,
		sub: subSteps,
	};
};

export { parseBELoopingToFE, parseFELoopingToBE };
